import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { ComponentBase, DbaDataTableColumn, DbaMAtTableDatatypesEnum, DialogData } from '@definitiv-packages/angular-dba-library';

import { DebitorModel, DebitorService, ObjektModelView, ProjectLanguage, ProjektPermissionService, StandortModelView, StandortService, StandortViewService } from '../../../../../roofsafetymanagement-library/src/public-api';

import { CreateStandortComponent } from '../../../../../roofsafetymanagement-library/src/lib/dialogs/create-standort/create-standort.component';

@Component({
  selector: 'app-standort-main-view',
  templateUrl: './standort-main-view.component.html',
  styleUrls: ['./standort-main-view.component.scss'],
  standalone: false
})
export class StandortMainViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public standortList: StandortModelView[] = [];
  public selectedStandort: StandortModelView | null = null;
  public debitorfilteredList: DebitorModel[] = [];
  public debitorList: DebitorModel[] = [];
  public debitorFilteredList: DebitorModel[] = [];
  public selectedDebitor: DebitorModel = new DebitorModel();

  public columnsdefMain: DbaDataTableColumn<StandortModelView, ProjectLanguage>[] = [
    { id: 'Bezeichnung', label: 'Bezeichnung' },
    { id: 'Strasse', label: 'Strasse' },
    { id: 'PLZ', label: 'PLZ' },
    { id: 'Ort', label: 'Ort' },
    { id: 'LandName', label: 'Land' },
    { id: 'DebitorNummer', label: 'debitornr' },
    { id: 'DebitorName', label: 'debitorname' }
  ];

  constructor(
    public permissionService: ProjektPermissionService,
    private standortViewService: StandortViewService,
    private standortService: StandortService,
    private debitorService: DebitorService,
    private dialog: MatDialog,
  ) { super(); }

  public async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
      this.standortList = await this.standortViewService.getFilteredList();
      this.debitorList = await this.debitorService.getList();
      this.debitorList.sort((a,b)=>{
          return (a.Name <b.Name)?-1:1
      })
      var alledebitor = new DebitorModel();
      alledebitor.DebitorID = 0;
      alledebitor.Name = "alle";

      this.debitorList.unshift(alledebitor);
      this.selectedDebitor = this.debitorList[0];
      this.debitorfilteredList = this.debitorList;      
    } finally {
      this.loading = false;
    }
  }

    public debitorFilter = (list: ObjektModelView[], filter: DebitorModel): ObjektModelView[] => {
      if (filter.DebitorID == undefined || filter.DebitorID == 0){           
          return list;
      }else{           
        //    this.selectedStandort = allestandort;
            return list.filter(x => x.DebitorID == filter.DebitorID);
      }
        
    }
  public async OpenDialog(data: DialogData<StandortModelView>): Promise<void> {
    
      if (!this.permissionService.StandortLesen) return;

      var standort = await firstValueFrom(this.dialog.open(CreateStandortComponent, { data: data }).afterClosed());

      if (!standort)
        return
      this.loading = true;
      try{
          var changedstandort = await this.standortViewService.get(standort.StandortID)

          this.selectedStandort = null;

          this.standortList = await this.standortViewService.getFilteredList();
          
          this.loading = false;
          this.selectedStandort = changedstandort;
      }catch{
          this.loading = false;
      }
  }

 
   public async deleteData(standortID : number): Promise<void> {
      this.loading = true;
      await this.standortService.delete(standortID);
      this.standortList =  await this.standortViewService.getList();
      this.loading = false;
  }
}
